export const zhCNWebsiteNode = {
  back: "后退",
  coldStatus: "冷启动",
  forward: "前进",
  reload: "刷新",
  close: "关闭",
  urlPlaceholder: "输入网址",
  loadFailed: "页面加载失败"
};
